// extracted by mini-css-extract-plugin
export var brand = "_4k-9";
export var compact = "_4k-6";
export var extraSmall = "_4k-7";
export var icon = "_4k-0";
export var large = "_4k-4";
export var light = "_4k-1";
export var medium = "_4k-5";
export var outline = "_4k-b";
export var primaryDark = "_4k-a";
export var primaryLight = "_4k-8";
export var primaryModern = "_4k-c";
export var success = "_4k-2";
export var successSolid = "_4k-3";